module.exports ={
    personInfo: {
    	userinfo:'Profile',
        head:'Profile Picture',
        name:'Username',
        nameMsg:'Please enter your name',
        username:'Name',
        usernameMsg:'Please enter your name',
        password:'Password',
        passwordMsg:'Please enter a user password',
        repeatPassword:'Re-enter Password',
        repeatPasswordMsg:'Please enter the user password again',
        save:'Save',
        saving:'Saving...',
        validMsg: {       //校验提示信息
            nickName:'Please enter your name',
            password:'Please enter a user password',
            length1:'Please enter password between 6 and 20 characters',
            length2:'Please enter a repeat password of 6 to 20 characters',
            password2:'Please enter the user password again',
            passRule:'User password cannot contain spaces',
            passRule2:'User password cannot contain Chinese',
            disPw:'Inconsistent input password twice'
        },
        hintMsg:{  //数据交互提示信息
            dialogTitle:'Modify',
            sure:'OK',
            updateSuccess:"Modify user's personal information successfully",
            // miss:'缺少请求参数',
            updateFail:'Personal information modification failed',
            queryFail:'Failed to query user information'
        },
        upload:{
            format:'Uploading avatar images can only be in JPG and PNG formats!',
            size:'Image size must be within 200*200!',
            fail: 'Upload failed'

        }

        
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/personInfo.js